import { render, staticRenderFns } from "./robot.vue?vue&type=template&id=4e625f6a&"
import script from "./robot.vue?vue&type=script&lang=js&"
export * from "./robot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e625f6a')) {
      api.createRecord('4e625f6a', component.options)
    } else {
      api.reload('4e625f6a', component.options)
    }
    module.hot.accept("./robot.vue?vue&type=template&id=4e625f6a&", function () {
      api.rerender('4e625f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/robot.vue"
export default component.exports